import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import { X } from 'lucide-react';
import './WhatsAppButton.css';

export default function WhatsAppButton() {
  const [showTooltip, setShowTooltip] = useState(false);
  const phoneNumber = '919876543210';
  const message = encodeURIComponent('Hi! I want to know more about Sculpit and designing my dream home.');

  return (
    <div className="whatsapp-wrapper">
      <AnimatePresence>
        {showTooltip && (
          <motion.div
            className="whatsapp-tooltip"
            initial={{ opacity: 0, y: 10, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.9 }}
          >
            <button className="whatsapp-tooltip__close" onClick={() => setShowTooltip(false)}>
              <X size={14} />
            </button>
            <p className="whatsapp-tooltip__text">
              <strong>Need help?</strong><br />
              Chat with us on WhatsApp. We typically reply within 5 minutes.
            </p>
            <a
              href={`https://wa.me/${phoneNumber}?text=${message}`}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-tooltip__btn"
            >
              <FaWhatsapp /> Start Chat
            </a>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        className="whatsapp-fab"
        onClick={() => setShowTooltip(!showTooltip)}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1.5, type: 'spring', stiffness: 200 }}
      >
        <FaWhatsapp size={28} />
        <span className="whatsapp-fab__pulse" />
      </motion.button>
    </div>
  );
}
